import { Stack } from "@mui/material";
import CustomDialog from "components/CustomDialog";
import CustomDataGrid from "components/customDataGrid";
import { currencyFormat, findKeyByValue } from "config/functions";
import { YESH_INVOICE_DOCUMENT_TYPE } from "containers/dashboard/const";
import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";

const PaymentsDetails = ({ data, setData, dialogTitle }) => {
    const { bt } = useBizTypeTranslation();
    const onClose = () => { setData(null) };

    return (
        <CustomDialog width={600} open={data ? true : false} onClose={onClose} title={dialogTitle}>
            <Stack>
                <CustomDataGrid
                    maxHeight={450}
                    minHeight={450}
                    borderRadius="10px 10px 10px 10px"
                    columns={[
                        {
                            field: "customerName",
                            headerName: bt("BIZ_NAME"),
                            filterable: true,
                            width: 200,
                        },
                        {
                            field: "documentType",
                            headerName: bt("DOCUMENT_TYPE"),
                            filterable: true,
                            width: 150,
                            valueFormatter: (params) => bt(findKeyByValue(YESH_INVOICE_DOCUMENT_TYPE, params))

                        },
                        {
                            field: "price",
                            headerName: bt("PAYMENT_AMOUNT"),
                            filterable: true,
                            width: 150,
                            valueFormatter: (params) => currencyFormat(params)
                        },
                    ]}
                    list={data?.map((item) => ({
                        ...item,
                    })) ?? []
                    }
                />

            </Stack>
        </CustomDialog>
    );
};
export default PaymentsDetails;